/**
 *
 *  Available type of button.
 *
 *  (i) Not providing a type makes it default to a blue button.
 *
 */
export enum ButtonType {
    /** Using a transparent background. */
    Transparent = 'transparent',

    /** Using a dark blue background. */
    Dark = 'dark',

    /** Using a green background. */
    Success = 'success',

    /** Using an orange background. */
    Warning = 'warning',
}

/**
 *  Holding the options for a button.
 */
export interface ButtonOptions {
    /** The type of button. */
    type?: ButtonType;

    /** The title of the button. */
    title: string;

    /** The content of the button. */
    content: string;

    /** If the button should be disabled. */
    disabled?: boolean;
}
